import { useCallback } from "react";

import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { AccountSecurityBanner } from "@/components/account/account-security-banner";
import {
  AffiliationsClient,
  AFFILIATIONS_VALID_TABS,
  type AffiliationsTab,
} from "@/components/account/provider/affiliations-client";

interface AffiliationsSearch {
  tab: AffiliationsTab;
}

export const Route = createFileRoute("/_authenticated/account/provider/affiliations")({
  validateSearch: (search: Record<string, unknown>): AffiliationsSearch => {
    const raw = typeof search.tab === "string" ? search.tab : "";
    return {
      tab: AFFILIATIONS_VALID_TABS.includes(raw as AffiliationsTab)
        ? (raw as AffiliationsTab)
        : "pending",
    };
  },
  component: ProviderAffiliationsPage,
});

function ProviderAffiliationsPage() {
  const { tab } = Route.useSearch();
  const navigate = useNavigate();
  const setTab = useCallback(
    (next: AffiliationsTab) =>
      navigate({ to: "/account/provider/affiliations", search: { tab: next } }),
    [navigate],
  );
  return (
    <>
      <AffiliationsClient activeTab={tab} onTabChange={setTab} />
      <AccountSecurityBanner />
    </>
  );
}
